var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "saas-error-page linear-error-page" }, [
    _c("div", { staticClass: "linear-error-card" }, [
      _c("div", { staticClass: "linear-error-card__code" }, [_vm._v("404")]),
      _vm._v(" "),
      _c("span", { staticClass: "linear-error-card__label" }, [
        _vm._v("Page unavailable"),
      ]),
      _vm._v(" "),
      _c("h1", [_vm._v(_vm._s(_vm.trans("general.page_not_found_heading")))]),
      _vm._v(" "),
      _c("p", [_vm._v(_vm._s(_vm.trans("general.page_not_found_message")))]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "linear-error-card__actions" },
        [
          _c(
            "router-link",
            {
              staticClass:
                "btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid",
              attrs: { to: "/" },
            },
            [_vm._v(_vm._s(_vm.trans("general.back_to_home")))]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }